import { render, staticRenderFns } from "./DeliverySetting.vue?vue&type=template&id=4ce80936"
import script from "./DeliverySetting.vue?vue&type=script&lang=js"
export * from "./DeliverySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports